import clsx from 'clsx'
import React from 'react'

import { SkeletonItem } from 'components/reusable/SkeletonItem'

import { UnderlinedTooltip } from '../../../components/ui/UnderlinedTooltip'

interface QuoteDetailsItemProps {
  label: string
  value: string
  variant?: 'default' | 'secondary'
  isLoading?: boolean
  tooltip?: string | React.ReactNode
}

export const QuoteDetailsItem = ({
  label,
  value,
  variant = 'default',
  isLoading = false,
  tooltip,
}: QuoteDetailsItemProps) => {
  return (
    <div className={clsx('flex items-center w-full')}>
      {tooltip
        ? (
          <UnderlinedTooltip content={tooltip} className='body text-gray-500'>
            {label}
          </UnderlinedTooltip>
          )
        : (
          <span className='body text-gray-500'>{label}</span>
          )}
      <div className='grow shrink-0 min-w-4 border-b border-dotted border-gray-300 mx-2' style={{ height: 0 }} />
      {isLoading
        ? (
          <SkeletonItem widthClass='w-20' heightClass='h-4' />
          )
        : (
          <span
            className={clsx('text-right', {
              'body-bold text-gray-800': variant === 'default',
              'body text-gray-500': variant === 'secondary',
            })}
          >
            {value}
          </span>
          )}
    </div>
  )
}
